import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@jetpack-labs/jetpack-ui/style.css'
import 'vue-sonner/style.css'
import './style.css'
import JetpackUI from '@jetpack-labs/jetpack-ui'

import App from './App.vue'
import router from './router'
import './api/interceptors'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(JetpackUI)

app.mount('#app')
